module.exports = __webpack_public_path__ + "static/media/OutliersMCQ3_1.e6c8b218.svg";